// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes } from 'react';
import StarRatingComponent from 'react-star-rating-component';

// import calendar icon
import RatingStar from '../../svgs/RatingStar';
import ActiveRatingStar from '../../svgs/ActiveRatingStar';

// js utilities
import cx from 'classnames';
import _ from 'lodash';

// function to validate individual values
import { validateField } from '../../../modelValidator';


export default class RatingStars extends Component {
  static propTypes = {
      className: PropTypes.string,
      defaultValue: PropTypes.any,
      value: PropTypes.any,
      id: PropTypes.any,
      disabled: PropTypes.bool,
      onChange: PropTypes.func,
      onBlur: PropTypes.func,
      floatingLabelText: PropTypes.string,
      validation: PropTypes.object,
      onErrorChange: PropTypes.func,
      readOnly: PropTypes.bool
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      value: 0,
      errors: []
    };
  }

  componentWillMount() {
    // check for initial value
    const initVal = this.props.hasOwnProperty('value') ? this.props.value :
      this.props.hasOwnProperty('defaultValue') ? this.props.defaultValue : null;

    const hasValidation = this.validate(initVal);
    if(!hasValidation && initVal) { // even without validation, should still set state to dirty if initial value is populated
      this.setState({value: initVal});
    }
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.value !== nextProps.value) {
      this.validate(nextProps.value);
      this.setState({value: nextProps.value});
    }
  }

  componentWillUnmount() {
    if(this.state.errors.length && this.props.onErrorChange) {
      this.props.onErrorChange(-1);
    }
  }

  onChange(newValue) {
    // if(!this.props.hasOwnProperty('value')) {
      this.validate(newValue);
      this.setState({value: newValue});
    // }
    if(this.props.onChange) {
      this.props.onChange(null, newValue);
    }
  }

  validate(value) {
    if(this.props.validation) {
      const errorsObj = {
        errors: validateField(value, this.props.validation)
      };
      if(errorsObj.errors.length !== this.state.errors.length) {
        if(this.props.onErrorChange) {
          this.props.onErrorChange(errorsObj.errors.length > this.state.errors ? 1 : -1);
        }
      }
    }
  }

  renderReadOnlyStars() {
        // populate stars
        let starNodes = [];
        for (let i = 1; i <= 5; i++) {
            const starNodeLabel = (
              <label className='dv-star-rating-star'>
                {
                  (i <= this.state.value)
                  &&
                  <ActiveRatingStar />
                }
                {
                  (i > this.state.value)
                  &&
                  <RatingStar />
                }
              </label>
            );
            starNodes.push(starNodeLabel);
        }
        return starNodes;
    }

  // Callback to render custom star icon.
  renderStarIcon(stateValue, i, value) {
    return  (
        <div>
        {
          (i <= stateValue)
          &&
          <ActiveRatingStar />
        }
        {
          (i > stateValue)
          &&
          <RatingStar />
        }
      </div>
    );
  }

  render() {
    return (
      <div className={`rating-stars-wrapper ${this.props.className || ''}`} tabIndex='0'>
        <div className='floatingLabelText' data-id={this.props.floatingLabelText}>
          {this.props.floatingLabelText}
        </div>
        {
          this.props.readOnly
          &&
          <div style={{display: 'inline-block', position: 'relative'}} className='dv-star-rating'>
            {this.renderReadOnlyStars()}
          </div>
        }
        {
          !this.props.readOnly
          &&
          <StarRatingComponent
                    name={this.props.id}
                    starCount={5}
                    value={this.state.value}
                    onStarClick={this.onChange.bind(this)}
                    renderStarIcon={this.renderStarIcon.bind(this, this.state.value)}
                    editing={!this.props.disabled}
                />
            }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/c_RatingStars/index.js